<template>
  <div class="courseWrap">
    <md-content class="md-scrollbar md-layout">
      <div
        v-for="item in courseList"
        cols="auto"
        :key="item._id"
        class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseItem"
      >
        <v-card elevation="2">
          <v-img
            :lazy-src="item.courseImg"
            class="coureListImg"
            height="140px"
            :src="item.courseImg"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="con">
            <p class="courseName">{{ item.courseName }}</p>
            <p class="studyTime">已学习{{ item.studyTime }}分钟</p>
            <div class="tostudy">
              <md-button class="md-simple md-sm" @click="navCourseDetail">{{ item.tostudy }}</md-button>
            </div>
          </div>
        </v-card>
      </div>
    </md-content>
  </div>
</template>

<script>
export default {
  // name:'learningCourses',学习课程
  data() {
    return {
      variants: ['one', 'two', 'tree', 'four'],
      courseList: [
        {
          _id: '1',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '2',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '3',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '4',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '5',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '6',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '7',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
        {
          _id: '8',
          courseName: '建筑电器施工技术',
          studyTime: '20',
          tostudy: '进入学习',
          courseImg:
            'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1705543151239/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240118092107.jpg',
        },
      ],
    };
  },
  methods: {
    navCourseDetail() {
      this.$router.push({
        path: '/SimClassDetails',
        query: {
          _id: '65ba13d4a7fa64a6f17664cf',
          type:'simclass'
        },
      });
    }
  }
};
</script>

<style scoped>
.courseWrap {
  width: 100%;
  height: auto;
  /* padding: 10px; */
  overflow: hidden;
  /* border: 1px solid gray; */
}

.courseItem {
  margin: 10px 0;
}
.con {
  width: 100%;
  height: auto;
  padding: 10px 0;
}
.courseName {
  font-size: 16px;
  margin-bottom: 10px;
  color: #000;
  padding: 0 10px;
}

.studyTime {
  font-size: 15px;
  color: #5b5b5b;
  margin-bottom: 10px;
  padding: 0 10px;
}
.tostudy {
  width: 100%;
  height: auto;
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid #a7a7a7;
}

.tostudy p {
  font-size: 14px;
  margin-bottom: 0px;
  line-height: 30px;
  height: 30px;
}

</style>
